import { Button, Flex, Text, useBreakpointValue, useToast, Input } from "@chakra-ui/react";
import { useEffect, useLayoutEffect, useState } from "react";

import { Input as InputForm, InputWithLabel } from "@/components/Input";
import { useAuth } from "@/contexts";
import { useClient } from "@/hooks/Client/useClient";
import { useUpdatePF } from "@/hooks/Client/useUpdatePF";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { parseISO } from "date-fns";
import { useAsynClientById } from "@/hooks/Client/useAsyncClientById";
import { useUpdateClient } from "@/hooks/Client/useUpdateClient";
import axios from "axios";

type Client = {
  name: string;
  document: string;
  date: string;
  phone: string;
  cellphone: string;
  email: string;
};

type Inputs = {
  phone: string;
  cellphone: string;
  email: string;
  date?: string;
};

export function FormMyAccount() {
  //* Define the initial state of the form
  const [editable, setEditable] = useState<boolean>(true);
  const [isPf, setIsPf] = useState<boolean>(true);
  const [name, setName] = useState<string>("");
  const [document, setDocument] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [cellphone, setCellphone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [oldEmail, setOldEmail] = useState<string>("");
  const [UserUpdate, setUserUpdate] = useState<boolean>(true);

  const toast = useToast({
    position: "bottom",
    duration: 4000,
    isClosable: true
  });
  const Auth = useAuth();
  const [ClientData, ClientError, ClientLoading] = useClient(Auth.clientId);

  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  const onSubmitAllData = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const testEmail = new RegExp(/(.+)@(.+){2,}\.(.+){2,}/);
    // * make all validations before submit the form
    switch (true) {
      case !phone ||
        phone.replace(/[^0-9]/g, "").length === 0 ||
        phone.replace(/[^0-9]/g, "").length < 10:
        toast.closeAll();
        toast({
          title: "Telefone obrigatório",
          status: "error"
        });
        return;
      case !cellphone ||
        cellphone.replace(/[^0-9]/g, "").length === 0 ||
        cellphone.replace(/[^0-9]/g, "").length < 11:
        toast.closeAll();
        toast({
          title: "Celular obrigatório",
          status: "error"
        });
        return;
      case !testEmail.test(email):
        toast.closeAll();
        toast({
          title: "E-mail obrigatório",
          status: "error"
        });
        return;
      case ClientData.type === "ClientePF" && date.replace(/[^0-9]/g, "").length < 8:
        toast.closeAll();
        toast({
          title: "Preencha a data corretamente",
          status: "error"
        });
        return;
      case ClientData.type === "ClientePF" && !name:
        toast.closeAll();
        toast({
          title: "Nome obrigatório",
          status: "error"
        });
    }
    console.log("date.length", date.replace(/[^0-9]/g, ""));
    // * if all validations are ok, submit the form

    const phoneNum = phone.replace(/[^0-9]/g, "");
    const cellphoneNum = cellphone.replace(/[^0-9]/g, "");

    const UpdateResponse = await axios.post("/api/UpdateClient", {
      clientId: Auth.clientId,
      email,
      name,
      date,
      phone: phoneNum,
      cellphone: cellphoneNum
    });

    const ClientResponse = UpdateResponse?.data?.ClientResponse;

    const ClientError = UpdateResponse?.data?.ClientError;

    toast.closeAll();
    console.log("ClientResponse", ClientResponse);
    console.log("ClientError", ClientError);

    if (ClientResponse.ClientResponse[0].length !== 0 && ClientError === undefined) {
      toast({
        title: "Alteração efetuada com sucesso",
        status: "success"
      });
      setEditable(true);
      return;
    } else if (ClientError !== undefined) {
      toast({
        title: "Erro ao atualizar dados",
        status: "error",
        description: ClientError
      });
      return;
    }

    return setUserUpdate(true);
  };

  useLayoutEffect(() => {
    return () => setUserUpdate(false);
  }, [UserUpdate]);

  useIsomorphicLayoutEffect(() => {
    if (ClientData) {
      const { type } = ClientData;
      switch (type) {
        case "ClientePF":
          setIsPf(true);
          var {
            email,
            telephones,
            clientPFData: { name, cpf, birthDate }
          } = ClientData;
          break;
        case "ClientePJ":
          setIsPf(false);
          var {
            email,
            telephones,
            clientPJData: { nomeFantasia, cnpj }
          } = ClientData;
          break;
      }
      setName(name ?? nomeFantasia);
      setDocument(cpf ?? cnpj);
      setPhone(telephones?.[0]?.number);
      if (isPf) {
        let dataNasc = parseISO(birthDate).toLocaleDateString("pt-br");
        setDate(dataNasc);
      }
      setCellphone(telephones?.[2]?.number);
      setEmail(email);
      setOldEmail(email);
    }
  }, [ClientData]);

  return (
    <Flex
      mt={"25px"}
      as="form"
      direction="column"
      width={["100%", "45%"]}
      onSubmit={onSubmitAllData}
    >
      <Text fontSize={"h3"} fontWeight={"600"} color={"ll-blue.main"}>
        Dados pessoais
      </Text>
      <Flex
        flexDir={"column"}
        w={"full"}
        borderTop={"1px dashed"}
        pt={"20px"}
        borderColor={"ll-gray.200"}
        mb={"15px"}
      >
        <Flex width="100%" mb="15px">
          <InputForm
            borderRadius={"50px"}
            bgColor={"white"}
            borderColor={"ll-gray.600"}
            height={"40px"}
            color={"ll-gray.300"}
            name="name"
            label="NOME COMPLETO"
            isDisabled={true}
            type="text"
            as="input"
            value={name}
            fontSize={!isWideVersion && "15px"}
            onChange={(e) => setName(e.target.value)}
          />
        </Flex>
        <Flex justifyContent="space-between" width="100%" mb="15px">
          {isPf && (
            <Flex width="48%">
              <InputForm
                borderRadius={"50px"}
                bgColor={"white"}
                borderColor={"ll-gray.600"}
                height={"40px"}
                color={"ll-gray.300"}
                mask="999.999.999-99"
                placeholder="123.123.123-12"
                isDisabled={true}
                type={"tel"}
                name="cpf"
                label="CPF"
                value={document}
                fontSize={!isWideVersion && "15px"}
                onChange={(e) => setDocument(e.target.value)}
              />
            </Flex>
          )}
          {!isPf && (
            <Flex width="100%">
              <InputForm
                borderRadius={"50px"}
                bgColor={"white"}
                borderColor={"ll-gray.600"}
                height={"40px"}
                color={"ll-gray.300"}
                mask="99.999.999/9999-99"
                placeholder="12.123.123/0001-12"
                isDisabled={true}
                name="cnpj"
                label="CNPJ"
                fontSize={!isWideVersion && "15px"}
                type={"tel"}
                value={document}
                onChange={(e) => setDocument(e.target.value)}
              />
            </Flex>
          )}
          <Flex width="48%" display={isPf ? "flex" : "none"}>
            {isPf && (
              <InputForm
                borderRadius={"50px"}
                bgColor={"white"}
                borderColor={"ll-gray.600"}
                height={"40px"}
                color={"ll-gray.300"}
                mask="99/99/9999"
                // isDisabled={true}
                placeholder="12/12/1212"
                fontSize={!isWideVersion && "15px"}
                name="date"
                value={date}
                type={"tel"}
                onChange={(e) => setDate(e.target.value)}
                label={"NASCIMENTO"}
                isDisabled={editable}
              />
            )}
          </Flex>
        </Flex>
        <Flex justifyContent="space-between" width="100%" mb="15px">
          <Flex width="48%">
            <InputForm
              borderRadius={"50px"}
              bgColor={"white"}
              borderColor={"ll-gray.600"}
              height={"40px"}
              color={"ll-gray.300"}
              mask={
                cellphone && cellphone.split("")[5] === "9" ? `(99) 99999-9999` : `(99) 9999-9999`
              }
              placeholder="(41) 55555-4444"
              name="celphone"
              fontSize={!isWideVersion && "15px"}
              value={cellphone}
              type={"tel"}
              label="CELULAR"
              onChange={(e) => setCellphone(e.target.value)}
              isDisabled={editable}
            />
          </Flex>
          <Flex width="48%">
            <InputForm
              borderRadius={"50px"}
              bgColor={"white"}
              borderColor={"ll-gray.600"}
              height={"40px"}
              color={"ll-gray.300"}
              mask={phone && phone.split("")[5] === "9" ? `(99) 99999-9999` : `(99) 9999-9999`}
              placeholder="(41) 4444-4444"
              fontSize={!isWideVersion && "15px"}
              name="phone"
              label="TELEFONE"
              type={"tel"}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              isDisabled={editable}
            />
          </Flex>
        </Flex>
        <Flex width="100%" mb="20px">
          <InputForm
            borderRadius={"50px"}
            bgColor={"white"}
            borderColor={"ll-gray.600"}
            height={"40px"}
            color={"ll-gray.300"}
            name="email"
            value={email}
            label="E-MAIL"
            fontSize={!isWideVersion && "15px"}
            type={"email"}
            onChange={(e) => setEmail(e.target.value)}
            isDisabled={editable}
          />
        </Flex>
        {editable && (
          <Button
            variant={"secondary-button"}
            h={"40px"}
            _hover={{ opacity: "0.5" }}
            onClick={() => setEditable(false)}
          >
            EDITAR DADOS
          </Button>
        )}
        {!editable && (
          <Button variant={"secondary-button"} h={"40px"} _hover={{ opacity: "0.5" }} type="submit">
            ATUALIZAR DADOS
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
